import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Maintenance from 'views/Maintenance';

const MaintenanceContainer = ({maintenance}) =>
{
    console.log('isMaintenance container', maintenance);
    return(
        <Maintenance maintenance={maintenance}/>
    );

};

export default MaintenanceContainer;